<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                :to="{ name: 'articles-ajout' }"
              >
                <span class="text-nowrap">Ajouter un article</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refArticlesListTable"
        class="position-relative"
        :items="fetchArticles"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: User -->
        <!-- <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template> -->

        <!-- Column: Role -->
        <template #cell(date)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ format_date(data.item.date) }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <!-- <template #cell(status)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template> -->

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item :to="{ name: 'articles-edit', params: { article: data.item } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editer</span>
            </b-dropdown-item>

            <b-dropdown-item 
             @click="deletePost(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Supprimer</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import moment from 'moment';
import useArticlesList from './useArticlesList'
import listArticlesStoreModule from './listArticlesStoreModule'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    // UsersListFilters,
    // UserListAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton, 
    BTable,
    BMedia,
    BAvatar,
    BLink, 
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
   methods: { 
      format_date(value){
        if (value) {
           return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      deletePost(id) {
        try {
          axios.delete('https://admin.ordredespharmaciens.sn/api/v1/dashboard/delete-articles/'+ id).then(res => { 
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: `Articles`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `Votre article a été retiré !`,
              },
            })
            })
            
            window.location.reload()
        } catch (error) {
          console.log("error", error);
        }
      }
   },
  setup() {

   
    const LIST_ARTICLES_APP_STORE_MODULE_NAME = 'app-list-articles'

    // Register module
    if (!store.hasModule(LIST_ARTICLES_APP_STORE_MODULE_NAME)) store.registerModule(LIST_ARTICLES_APP_STORE_MODULE_NAME, listArticlesStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(LIST_ARTICLES_APP_STORE_MODULE_NAME)) store.unregisterModule(LIST_ARTICLES_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)
     
    const {
      fetchArticles,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refArticlesListTable,
      refetchData,

      // UI

      // Extra Filters
    } = useArticlesList()

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchArticles,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refArticlesListTable,
      refetchData,

      // Filter
      avatarText,
    }
  }
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
